<script>
import FishingYearSelector from '@/components/UI/FishingYearSelector.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'WellCome',
	components: {
		FishingYearSelector,
	},
	props: {
		isSalesman: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		...mapGetters('dashboard', ['getSelectedFishingYear', 'isLoading']),
		userId() {
			return this.$store?.state?.userObject?.role_id
		},
		getUserTag() {
			if ([3].includes(this.userId)) return `subject`
			return `tir-go`
		},
	},
	mounted() {
		// Initialize dashboard with default fishing year
		this.initializeDashboard(this.getUserTag)
	},
	methods: {
		...mapActions('dashboard', ['setFishingYear', 'initializeDashboard']),
		async handleFishingYearChange(fishingYear) {
			await this.setFishingYear({ fishingYear, userTag: this.getUserTag })
			// Emit event to parent to refresh other components
			this.$emit('fishing-year-changed', fishingYear)
		},
	},
}
</script>

<template>
	<div
		class="relative z-10 bg-white/90 p-[20px] sm:p-[30px] shadow-main rounded-[10px] backdrop-blur-[10px] flex flex-col lg:flex-row justify-between gap-4 lg:gap-12 overflow-visible"
	>
		<div class="pl-[13px] border-l-[4px] border-l-solid border-main">
			<div
				class="font-main font-bold text-[16px] sm:text-[18px] uppercase text-third leading-[1.22]"
			>
				{{ $t('admin.hello.title') }}
			</div>
			<div class="font-main font-normal text-[12px] sm:text-[14px] text-second leading-[1.22]">
				{{ $t('admin.hello.desc') }}
			</div>
		</div>
		<div class="flex items-center justify-end lg:justify-end w-1/2 overflow-visible relative">
			<FishingYearSelector
				v-if="!isSalesman"
				:model-value="getSelectedFishingYear"
				@change="handleFishingYearChange"
				:title="$t('admin.hello.fishing_year')"
				:disabled="isLoading"
			/>
		</div>
	</div>
</template>
